import React from "react";
import {
  Waves,
  Dumbbell,
  Mountain,
  Flame,
  Flower2,
  Baby,
  Utensils,
  PawPrint,
} from "lucide-react";
import { ARIAKE } from "../lib/data";

const ICONS = {
  waves: Waves,
  dumbbell: Dumbbell,
  mountain: Mountain,
  flame: Flame,
  "flower-2": Flower2,
  baby: Baby,
  utensils: Utensils,
  "paw-print": PawPrint,
};

export default function Amenities() {
  return (
    <section
      id="amenities"
      data-testid="amenities-section"
      className="relative bg-black text-white py-20 md:py-28 lg:py-32 overflow-hidden"
    >
      <div className="container-hh relative">
        <div className="reveal max-w-2xl">
          <div className="flex items-center gap-3 sm:gap-4 mb-5 sm:mb-6">
            <span className="accent-line" style={{ background: "hsl(var(--hh-sunrise))" }} />
            <span className="overline text-white/60" style={{ fontSize: "0.65rem" }}>
              Amenities
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-balance">
            Para{" "}
            <em style={{ fontStyle: "italic", color: "hsl(var(--hh-sunrise))" }}>
              toda la familia.
            </em>
          </h2>
          <p className="mt-5 text-white/65 text-sm md:text-base max-w-xl leading-relaxed">
            Más de 2.900 m² de áreas verdes comunales y ocho espacios pensados
            para vivir, descansar y compartir.
          </p>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10">
          {ARIAKE.amenities.map((a, i) => {
            const Icon = ICONS[a.icon] || Waves;
            return (
              <div
                key={a.name}
                data-testid={`amenity-${a.name.toLowerCase().replace(/\s+/g, "-").replace(/°/g, "")}`}
                className="bg-black p-6 sm:p-8 md:p-10 flex flex-col items-start gap-4 hover:bg-[hsl(var(--hh-moss))] transition-colors duration-500 group"
              >
                <Icon
                  size={26}
                  strokeWidth={1.2}
                  className="text-[hsl(var(--hh-sunrise))] group-hover:text-white transition-colors"
                />
                <div>
                  <div className="overline text-white/40 group-hover:text-white/70" style={{ fontSize: "0.52rem" }}>
                    0{i + 1}
                  </div>
                  <div className="font-display text-lg sm:text-xl md:text-2xl mt-1">{a.name}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
